import { useMemo } from "react";
import { Group } from "../types/Group";
import Section from "../types/Section";
import useFormTree from "./useFormTree";

export interface WizardFormTree {
  children: { section: Section; idx: number }[];
  group?: Group;
  type: "group" | "section";
}

function useWizardFormTree(
  schema: Section[],
  groups: Group[]
): WizardFormTree[] {
  const standardTree = useFormTree(schema, groups, {
    ignoreAdministrative: true,
  });

  const tree = useMemo(() => {
    const filtered = standardTree.filter((e) => e.children.length > 0);
    const split = filtered.flatMap((e): WizardFormTree | WizardFormTree[] => {
      if (e.group)
        return { children: e.children, type: "group", group: e.group };
      return e.children.map((c) => ({ children: [c], type: "section" }));
    });
    return split;
  }, [standardTree]);
  return tree;
}

export default useWizardFormTree;
